module.exports = __webpack_public_path__ + "static/media/ic_draganddrop.b1012338.svg";